import { showWalletConnectModal } from 'store/features/wallet/walletSlice';
import { Button } from '@dapp/multi-lib/sdaoui/Button';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'store/hooks';

interface ConnectButtonProps {
  className?: string;
  label?: string;
}

export const ConnectButton = (props: ConnectButtonProps) => {
  const { t } = useTranslation('common');
  const dispatch = useAppDispatch();

  const { className, label = t('CONNECT') } = props;
  const handleButtonClick = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(showWalletConnectModal(true));
  };
  return (
    <Button className={className} onClick={handleButtonClick}>
      {label}
    </Button>
  );
};
